import firebase from 'firebase';

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyCGcEOP7V4dtEE76KwPAV3NEsyt-hajblM",
  authDomain: "facebook-messenger-clone-84b2c.firebaseapp.com",
  databaseURL: "https://facebook-messenger-clone-84b2c.firebaseio.com",
  projectId: "facebook-messenger-clone-84b2c",
  storageBucket: "facebook-messenger-clone-84b2c.appspot.com",
  messagingSenderId: "1043068589540",
  appId: "1:1043068589540:web:be0db9f830aca682a3e3f1",
  measurementId: "G-HTBH7W8953"
});

const db = firebaseApp.firestore()

export default db;